import React, { useState } from 'react';  
import axios from 'axios';  
import Table from './components/Table';  
import ExcelJS from 'exceljs';  
import { saveAs } from 'file-saver';
import { processResponseData } from './dataProcessor';  
import InfoTable from './components/InfoTable';  
import './App.css';  
  
const instance = axios.create({  
  baseURL: process.env.REACT_APP_NODE_URL,  
  timeout: 10000,  
  headers: {  
    'Content-Type': 'application/json',  
    'Referrer-Policy': 'no-referrer-when-downgrade',  
    'Access-Control-Allow-Origin': '*',  
  },  
}); 
  
const maskSensitiveInformation = (str) => {  
  if (!str) return str;  
  return str  
    .replace(/(accessKeyId\s*:\s*['"]?)([^'"]+)(['"]?)/i, '$1****$3')  
    .replace(/(secretAccessKey\s*:\s*['"]?)([^'"]+)(['"]?)/i, '$1****$3')  
    .replace(/(sessionToken\s*:\s*['"]?)([^'"]+)(['"]?)/i, '$1****$3');  
};  
  
const App = () => {  
  const [query, setQuery] = useState("");  
  const [data, setData] = useState([]);  
  const [error, setError] = useState(null);  
  
  const handleQueryChange = (e) => {  
    setQuery(e.target.value);  
  };  
  
  const handleSubmit = async (e) => {  
    e.preventDefault();  
    try {  
      const response = await instance.post('/graphql', { query });  
      if (response?.data?.errors) {  
        const errorMessage = response.data.errors.map(err => err.message).join(", ");  
        throw new Error(errorMessage);  
      }  
      const processedData = processResponseData(response.data.data);  
      setData(processedData);  
    } catch (error) {  
      console.error('Error caught in handleSubmit:', maskSensitiveInformation(error.message));  
      setError(error);  
    }  
  };  
  
  if (error) {  
    throw error;  
  }  
  
  const handleDownload = async () => {  
    if (data.length > 0) {  
      const workbook = new ExcelJS.Workbook();  
      const worksheet = workbook.addWorksheet("Data");  
  
      const headers = Object.keys(data[0]);  
      worksheet.columns = headers.map((header) => ({ header, key: header }));  
  
      data?.forEach((row) => {  
        worksheet.addRow(row);  
      });  
  
      const buffer = await workbook.xlsx.writeBuffer();  
      const blob = new Blob([buffer], {  
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",  
      });  
      saveAs(blob, "data.xlsx");  
    }  
  };  
  
  return (  
    <div className="App">  
      <form onSubmit={handleSubmit}>  
        <div className="form-container">  
          <textarea  
            value={query}  
            onChange={handleQueryChange}  
            placeholder="Enter GraphQL query here"  
          />  
          <div className="info-table-container">  
            <InfoTable query={query} />  
          </div> 
        </div>  
        <button type="submit" className="submit-button">Submit</button>  
      </form> 
      {data.length > 0 && (  
        <>  
          <Table data={data} />  
          <button className="download-button" onClick={handleDownload}>Download as Excel</button>  
        </>  
      )}    
    </div>  
  );  
};  
  
export default App;  